import { INFORMATION_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/information/index.js